import { Fragment, useState } from "react";
import "./ContactForm.scss";
import TextError from "./textError/TextError";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { MdOutlineCheck } from "react-icons/md";
import { baseUrl, storContact } from "../../../utils/apiData";
import { motion } from "framer-motion";
import axios from "axios";
import { AiOutlineClose } from "react-icons/ai";

const ContactForm = () => {
  const goTo = () => {
    const section = document.getElementById("top");
    if (section) {
      window.scrollTo({
        top: section.offsetTop,
        behavior: "smooth",
      });
    }
  };

  const [loader, setLoader] = useState(false);
  const [accept, setAccept] = useState(false);
  const [success, setSuccess] = useState(false);

  const initialValues = {
    first_name: "",
    last_name: "",
    email: "",
    message: "",
    subject: "",
  };

  const validationSchema = Yup.object({
    first_name: Yup.string().required("Field is required!"),
    email: Yup.string()
      .email("Invalid email format!")
      .required("Email is required!"),
    subject: Yup.string().required("Field is required!"),
    message: Yup.string().required("Field is required!"),
  });

  const contactFormApi = async (data) => {
    setLoader(true);
    try {
      const res = await axios.post(`${baseUrl}/${storContact}`, { ...data });
      if (res?.data?.success) {
        goTo();
        setSuccess(true);
      }
    } catch (error) {
      console.log(error);
    }
    setLoader(false);
  };

  const onSubmit = (values, { resetForm }) => {
    contactFormApi({ ...values, terms_condition: accept });
    resetForm();
    setAccept(false);
  };

  return (
    <section className="contact_form_sec p_t p_b" id="top">
      <div className="content_wrap">
        <div className="contact_wrap">
          {success ? (
            <Fragment>
              <button
                type="button"
                className="close_btn"
                onClick={() => setSuccess(false)}
              >
                <AiOutlineClose />
              </button>
              <div className="success_screen">
                <h3 className="text-center">Thanks!</h3>
                <p className="text-center">We will reach you soon...</p>
              </div>
            </Fragment>
          ) : (
            <Fragment>
              <motion.h3
                initial={{ translateY: 32, opacity: 0 }}
                whileInView={{ translateY: 0, opacity: 1 }}
                transition={{ duration: 0.6, ease: "easeInOut" }}
                viewport={{ once: true }}
              >
                Send a message
              </motion.h3>

              <div className="form_wraper">
                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={onSubmit}
                >
                  <Form>
                    <div className="field_grid">
                      <motion.div
                        initial={{ translateY: 32, opacity: 0 }}
                        whileInView={{ translateY: 0, opacity: 1 }}
                        transition={{ duration: 0.6, ease: "easeInOut" }}
                        viewport={{ once: true }}
                        className="field_wrap"
                      >
                        <Field
                          type="text"
                          placeholder="First Name"
                          id="FName"
                          name="first_name"
                          autoComplete="off"
                        />
                        <ErrorMessage name="first_name" component={TextError} />
                      </motion.div>
                      <motion.div
                        initial={{ translateY: 32, opacity: 0 }}
                        whileInView={{ translateY: 0, opacity: 1 }}
                        transition={{ duration: 0.6, ease: "easeInOut" }}
                        viewport={{ once: true }}
                        className="field_wrap"
                      >
                        <Field
                          type="text"
                          placeholder="Last Name"
                          id="LName"
                          name="last_name"
                          autoComplete="off"
                        />
                        <ErrorMessage name="last_name" component={TextError} />
                      </motion.div>
                    </div>

                    <div className="field_grid">
                      <motion.div
                        initial={{ translateY: 32, opacity: 0 }}
                        whileInView={{ translateY: 0, opacity: 1 }}
                        transition={{
                          duration: 0.6,
                          ease: "easeInOut",
                          delay: 0.15,
                        }}
                        viewport={{ once: true }}
                        className="field_wrap"
                      >
                        <Field
                          type="email"
                          placeholder="Email"
                          id="Email"
                          name="email"
                          autoComplete="off"
                        />
                        <ErrorMessage name="email" component={TextError} />
                      </motion.div>
                      <motion.div
                        initial={{ translateY: 32, opacity: 0 }}
                        whileInView={{ translateY: 0, opacity: 1 }}
                        transition={{
                          duration: 0.6,
                          ease: "easeInOut",
                          delay: 0.15,
                        }}
                        viewport={{ once: true }}
                        className="field_wrap"
                      >
                        <Field
                          type="text"
                          placeholder="Your Subject"
                          id="subject"
                          name="subject"
                          autoComplete="off"
                        />
                        <ErrorMessage name="subject" component={TextError} />
                      </motion.div>
                    </div>

                    <motion.div
                      initial={{ translateY: 32, opacity: 0 }}
                      whileInView={{ translateY: 0, opacity: 1 }}
                      transition={{
                        duration: 0.6,
                        ease: "easeInOut",
                        delay: 0.3,
                      }}
                      viewport={{ once: true }}
                      className="field_wrap"
                    >
                      <Field
                        as="textarea"
                        type="text"
                        placeholder="Your message"
                        id="message"
                        name="message"
                        autoComplete="off"
                      />
                      <ErrorMessage name="message" component={TextError} />
                    </motion.div>
                    <motion.div
                      initial={{ translateY: 32, opacity: 0 }}
                      whileInView={{ translateY: 0, opacity: 1 }}
                      transition={{
                        duration: 0.6,
                        ease: "easeInOut",
                        delay: 0.45,
                      }}
                      viewport={{ once: true }}
                      className="check_wrap"
                    >
                      <div
                        className={`box ${accept ? "active" : ""}`}
                        onClick={() => setAccept((prev) => !prev)}
                      >
                        {accept && <MdOutlineCheck />}
                      </div>
                      <p className="t_16">
                        I am bound by the terms of the Service I accept Privacy
                        Policy.
                      </p>
                    </motion.div>
                    <motion.button
                      initial={{ translateY: 32, opacity: 0 }}
                      whileInView={{ translateY: 0, opacity: 1 }}
                      transition={{
                        duration: 0.6,
                        ease: "easeInOut",
                        delay: 0.15,
                      }}
                      type={loader ? "Button" : "submit"}
                      className="main_btn"
                    >
                      <p className="t_14">{loader ? "Loading..." : "Submit"}</p>
                    </motion.button>
                  </Form>
                </Formik>
              </div>
            </Fragment>
          )}
        </div>
      </div>
    </section>
  );
};
export default ContactForm;
